import { AxiosInstance } from 'axios';
import { HouseKeepingRootService } from 'services';

export interface HousekeepingReportServiceModel {
  getAll: ReturnType<typeof HouseKeepingRootService.getAll>;
  exportPDF: ReturnType<typeof HouseKeepingRootService.exportPDF>;
  update: ReturnType<typeof HouseKeepingRootService.update>;
  roomControl: ReturnType<typeof HouseKeepingRootService.roomControl>;
  closeDay: ReturnType<typeof HouseKeepingRootService.closeDay>;
}

export const initHousekeepingReportService = (
  axios: AxiosInstance
): HousekeepingReportServiceModel => ({
  getAll: HouseKeepingRootService.getAll(axios),
  exportPDF: HouseKeepingRootService.exportPDF(axios),
  update: HouseKeepingRootService.update(axios),
  roomControl: HouseKeepingRootService.roomControl(axios),
  closeDay: HouseKeepingRootService.closeDay(axios),
});
